<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<!-- Summary -->
				<app-tab-item :tab="tab" value="summary">
					<app-heading :title="complex.name" />
				</app-tab-item>

				<!-- Features -->
				<app-tab-item :tab="tab" value="features">
					<app-heading :title="`${complex.name} Features`" />
					<app-row>
						<app-cell>
							<app-data-table
								:items="features.items"
								:total="features.count"
								:headers="features.headers"
								@update="fetchFeatures"
							/>
						</app-cell>
					</app-row>
				</app-tab-item>

				<!-- Channels -->
				<app-tab-item :tab="tab" value="channels">
					<app-heading :title="`${complex.name} Channels`" />
					<app-row>
						<app-cell>
							<app-data-table
								:items="channels.items"
								:total="channels.count"
								:headers="channels.headers"
								@update="fetchChannels"
							>
								<template v-slot:content="{ item }">
									<app-json :data="getComplexChannelContent(item._id)" />
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import Tab from '@/types/Tab'
import DataTable from '@/types/DataTable'

export default {
	async created() {
		try {
			this.complex = await this.$ravello.request()
				.v(2)
				.to('resorts')
				.to(this.resort)
				.to('complexes')
				.to(this.id)
				.get()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}

		this.tabs = [new Tab('summary', {
			name: 'Summary',
			to: { name: 'studeo-resort-complex', params: { resort: this.resort, complex: this.id } },
			value: `/studeo-resorts/${this.resort}/complexes/${this.id}`,
			exact: true,
		}), new Tab('features', {
			name: 'Features',
			to: { name: 'studeo-resort-complex-child', params: { resort: this.resort, complex: this.id, ctab: 'features' } },
			value: `/studeo-resorts/${this.resort}/complexes/${this.id}/features`,
		}), new Tab('channels', {
			name: 'Channels',
			to: { name: 'studeo-resort-complex-child', params: { resort: this.resort, complex: this.id, ctab: 'channels' } },
			value: `/studeo-resorts/${this.resort}/complexes/${this.id}/channels`,
		})]
	},
	data() {
		return {
			complex: {
				name: '',
			},
			tabs: [],
			rooms: {},
			features: new DataTable([{
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: true,
			}]),
			channels: new DataTable([{
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Complex content',
				value: 'content',
				sortable: false,
			}]),
		}
	},
	computed: {
		resort() {
			return this.$route.params.resort
		},
		id() {
			return this.$route.params.complex
		},
	},
	methods: {
		async fetchFeatures(pagination) {
			const request = this.$ravello.request()
				.v(2)
				.to('resorts')
				.to(this.resort)
				.to('complexes')
				.to(this.id)
				.to('features')
				.fromPagination(pagination)

			try {
				this.features.items = await request.get()
				if (this.features.count === -1) {
					const count = await request.count()
					this.features.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async fetchChannels(pagination) {
			const request = this.$ravello.request()
				.v(2)
				.to('resorts')
				.to(this.resort)
				.to('complexes')
				.to(this.id)
				.to('channels')
				.fromPagination(pagination)

			try {
				this.channels.items = await request.get()
				if (this.channels.count === -1) {
					const count = await request.count()
					this.channels.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		getComplexChannelContent(id) {
			return this.complex.channels.find(channel => channel.channel === id)
		},
	},
}
</script>
